import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
const RADIOMARK_SIZE = 18;
const wrapperStaticStyle = css({
    alignItems: 'center',
    display: 'flex',
});
export function wrapperStyle({ disabled, inverted }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        wrapperStaticStyle,
        css({
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? tokens.opacity.medium : 1,
        }),
    ];
}
export const inputStaticStyle = css({
    cursor: 'inherit',
    height: RADIOMARK_SIZE,
    margin: 0,
    opacity: 0,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: RADIOMARK_SIZE,
});
export const labelStaticStyle = css({
    color: theme.text.main,
    cursor: 'inherit',
    lineHeight: tokens.lineHeights.default,
    paddingLeft: tokens.spacingNew.xsmall,
    paddingTop: '1px',
    userSelect: 'none',
});
const radiomarkStaticStyle = css({
    '&::after': {
        borderRadius: tokens.borderRadius.circle,
        content: '""',
        display: 'block',
        inset: 0,
        margin: '-3px',
        pointerEvents: 'none',
        position: 'absolute',
        transition: 'box-shadow 125ms ease-out',
        zIndex: tokens.zIndex.default,
    },
    alignItems: 'center',
    backgroundColor: theme.background.contrast,
    borderColor: theme.border.interactive,
    borderRadius: tokens.borderRadius.circle,
    borderStyle: 'solid',
    borderWidth: tokens.borderWidth.thin,
    display: 'flex',
    flexShrink: 0,
    height: RADIOMARK_SIZE,
    justifyContent: 'center',
    pointerEvents: 'none',
    position: 'relative',
    transition: 'background-color 75ms ease-out, border-color 75ms ease-out',
    width: RADIOMARK_SIZE,
});
const radiomarkErrorStaticStyle = css({
    borderColor: theme.error.darker,
    boxShadow: `0 0 0 1px ${theme.error.darker}`,
});
const radiomarkFocusStaticStyle = css({
    '&::after': {
        boxShadow: `0 0 0 2px ${theme.border.focusOutline}`,
    },
});
const radiomarkDisabledStaticStyle = css({
    backgroundColor: theme.background.tertiary,
});
export function radiomarkStyle({ disabled, hasError, isFocusVisible, }) {
    return [
        radiomarkStaticStyle,
        ...(isFocusVisible ? [radiomarkFocusStaticStyle] : []),
        ...(disabled ? [radiomarkDisabledStaticStyle] : []),
        ...(hasError ? [radiomarkErrorStaticStyle] : []),
    ];
}
const radioIconStaticStyle = css({
    borderRadius: tokens.borderRadius.circle,
    display: 'block',
    height: '8px',
    width: '8px',
});
export function radioIconStyle({ disabled }) {
    return [
        radioIconStaticStyle,
        css({
            backgroundColor: disabled ? theme.text.subtle : theme.blue.darker,
        }),
    ];
}
